/**
 * Employee Web — `/me/loans/$id` own-schedule route.
 *
 * Phase 17 Plan 02. Read-only schedule view via `useMeLoanSchedule`.
 * Permission gate: `loan:read:self`. UUID shape guarded so non-UUID URLs
 * 404 deterministically.
 */
import type { JSX } from "react";
import { createFileRoute, notFound } from "@tanstack/react-router";
import { requirePermission } from "@linkhr/auth";
import { MeLoanDetail } from "../features/loans/MeLoanDetail";

const UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

const permissionGate = requirePermission({
  anyOf: ["loan:read:self"],
  defaultRoute: "/me/overview",
});

export const Route = createFileRoute("/_auth/me/loans/$id")({
  staticData: { breadcrumb: { labelKey: "loans:me.loans.page.title" } },
  beforeLoad: (args) => {
    if (!UUID_REGEX.test(args.params.id)) {
      throw notFound();
    }
    permissionGate(args);
  },
  component: MeLoanDetailRoute,
});

function MeLoanDetailRoute(): JSX.Element {
  const { id } = Route.useParams();
  return <MeLoanDetail loanId={id} />;
}
